import script from "./PersonalMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalMessage.vue?vue&type=script&setup=true&lang=js"

import "./PersonalMessage.vue?vue&type=style&index=0&id=aeb0d616&lang=css"

const __exports__ = script;

export default __exports__